import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router'
import css from './TabBarItem.module.css'

const TabBarItem = ({ className, children, icon, active, ...props }) => (
  <Link className={cx({
    [css.wrapper]: true,
    [className]: !!className,
    [css.active]: active
  })} {...props}>
    {icon && <div className={css.icon}>{icon}</div>}
    {children}
  </Link>
)

TabBarItem.displayName = 'TabBarItem'

export default TabBarItem



// WEBPACK FOOTER //
// ./components/Customers/presentational/TabBarItem.js